import { Chip } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { PublicKeyLink } from "components/PublicKeyLink";
import { Branch, exposesPersonalData } from "types/branch";
import { EventRsvp } from "types/event";

export const rsvpCols = (
  branch: Branch | undefined
): GridColDef<EventRsvp>[] => [
  {
    field: "walletAddress",
    headerName: "Wallet",
    flex: 1,
    renderCell: function render({ row }) {
      return <PublicKeyLink pubKey={row.walletAddress} />;
    },
  },
  ...(exposesPersonalData(branch)
    ? [
        {
          field: "memberName",
          headerName: "Name",
          flex: 1,
          renderCell: function render({ row }: { row: EventRsvp }) {
            return row.memberName ?? "-";
          },
        } as GridColDef<EventRsvp>,
        {
          field: "memberEmail",
          headerName: "Email",
          flex: 1,
          renderCell: function render({ row }: { row: EventRsvp }) {
            return row.memberEmail ?? "-";
          },
        } as GridColDef<EventRsvp>,
      ]
    : []),
  {
    field: "status",
    headerName: "Status",
    flex: 1,
    renderCell: function render({ row }) {
      return (
        <Chip
          color={row.status === "ACCEPTED" ? "success" : "error"}
          label={row.status}
          variant="outlined"
        />
      );
    },
  },
  {
    field: "updatedAt",
    headerName: "Updated",
    flex: 1,
    renderCell: function render({ row }) {
      return <span>{new Date(row.updatedAt).toLocaleString()}</span>;
    },
  },
];
